import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import MainLayout from 'layout/MainLayout';
// login option 3 routing

import AdminPanel from '../pages/AdminPanel';
import AddNewUser from 'pages/AddNewUser';
import TimeZonePage from '../pages/TimeZonePage';
import ClientOnboard from '../pages/ClientOnboard';
import { Schedule } from '@mui/icons-material';
import ScheduleReportPage from '../pages/ScheduleReportPage';
// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    // {
    //   path: '/pages/admin/usertimezone',
    //   element: <TimeZonePage />
    // }
    // {
    //   path: '/pages/clientonboard',
    //   element: <ClientOnboard />
    // },
    // {
    //   path: '/pages/schedulereport',
    //   element: <ScheduleReportPage />
    // }
  ]
};

export default AuthenticationRoutes;
